import React, { Component } from 'react'

export default class Divider extends Component {
  render () {
    return (
      <div className="block h-px w-24 mx-auto my-6 bg-gray-200" />
    )
  }
}
